import React from 'react'
import PropTypes from 'prop-types'

import { logoStyle, setBackgroundColor } from './config'

import classes from './styles.module.scss'

const StartScreenHeader = ({ settings }) => (
  <div
    className={classes.topContainer}
    style={setBackgroundColor(settings.color)}>
    <div className={classes.logoHolder}>
      <img
        className={classes.logo}
        src={settings.logo}
        style={logoStyle}
        alt=""
      />
    </div>
    <div className={classes.textHolder}>
      <h2 className={classes.title} dir={settings.isRtl && 'rtl'}>
        {settings.welcomeTitle}
      </h2>
      <p className={classes.greetingText} dir={settings.isRtl && 'rtl'}>
        {settings.welcomeSubtitle}
      </p>
    </div>
  </div>
)

StartScreenHeader.propTypes = {
  classes: PropTypes.object,
  settings: PropTypes.shape({
    logo: PropTypes.string,
    color: PropTypes.string,
    title: PropTypes.string,
    bot_name: PropTypes.string,
    popup_text: PropTypes.string,
    popup_delay: PropTypes.number,
    greeting_text: PropTypes.string,
    chat_history_level: PropTypes.string,
    is_background_blurred: PropTypes.bool,
    enable_login_name_field: PropTypes.bool,
    enable_login_email_field: PropTypes.bool,
    is_composer_input_enabled: PropTypes.bool,
  }),
}

export default StartScreenHeader
